<template>
    <div>
        <div class="tb-navbar">
            <div class="row">
                <div class="col-9 col-md-3">
                    <router-link to="/admin">
                        <img class="tb-navbar__logo" src="@/assets/ca_logo.svg">
                    </router-link>
                </div>

                <div class="col-3 col-md-9">
                    <div class="tb-navbar__right">
                        <a href="#" class="tb-navbar__dropdown-toggle"
                            @click.prevent="toggleDropdown()">
                            <span class="inline-fa">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M442 114H6a6 6 0 0 1-6-6V84a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6z"/></svg>
                            </span>
                        </a>
                    </div>
                </div>
            </div>

            <transition name="slide">
                <div class="tb-navbar__menu" v-if="is_dropdown">
                    <span class="tb-navbar__menu-item" @click.prevent="hideDropdown()">
                        <router-link :to="'/admin'">
                            Manage All
                        </router-link>
                    </span>

                    <span class="tb-navbar__menu-item" @click.prevent="hideDropdown()">
                        <router-link :to="'/admin/users'">
                            Manage Users
                        </router-link>
                    </span>

                    <span class="tb-navbar__menu-item" @click.prevent="hideDropdown()">
                        <router-link :to="'/admin/clients'">
                            Manage Clients
                        </router-link>
                    </span>

                    <span class="tb-navbar__menu-item" @click.prevent="hideDropdown()">
                        <router-link :to="'/admin/events'">
                            Manage Events
                        </router-link>
                    </span>

                    <span class="tb-navbar__menu-item tb-navbar__menu-item--right"
                        @click.prevent="hideDropdown()">
                        <a href="#" @click.prevent="logout()">
                            Log Out
                        </a>
                    </span>
                </div>
            </transition>
        </div>

        <div class="py-5">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {api} from "@/repository/repository.js";

    export default {
        data: () => {
            return {
                is_dropdown: false
            }
        },

        computed: {
            user() {
                return this.$store.getters.user;
            }
        },

        methods: {
            hideDropdown() {
                console.log('x');
                this.is_dropdown = false;
            },

            toggleDropdown() {
              this.is_dropdown = !this.is_dropdown;
            },

            logout() {
                api.get('/logout')
                    .then(response=>{
                        // console.log('logged out');
                        window.location = '/';
                        //
                    });
            }
        }
    }
</script>

<style lang="scss">

    .logo {
        //max-width: 300px;
    }
    a.router-link-active {
        color: white!important;
    }

    .tb-dropdown-menu {

    }
</style>